import { Component, AfterViewChecked, ElementRef, OnDestroy, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderService } from 'src/app/shared/service/loader.service';
import { ToastMessageService } from 'src/app/shared/service/toast-message.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MarkdownModule } from 'ngx-markdown';
import { AiAgentService } from '../shared/service/ai-agent.service';

@Component({
  selector: 'app-ai-agent-search',
  imports: [CommonModule, FormsModule, MarkdownModule],
  standalone: true,
  templateUrl: './ai-agent-search.component.html',
  styleUrl: './ai-agent-search.component.scss'
})
export class AiAgentSearchComponent implements OnInit, OnDestroy, AfterViewChecked {


  @ViewChild('scrollChat') private chatContainer!: ElementRef;
  @ViewChild('scrollChat') scrollChat!: ElementRef;
  chatData: any[] = [];
  prompt: string = '';
  goal: string = '';
  backstory: string = '';
  isLoading: boolean = false;
  isSupervisorModeEnabled: boolean = true;
  isBingSelected: boolean = true;  // Default to Bing
  selectedModel: string = 'azure_openai';


  private chatSubscriber!: Subscription;
  welcomeChat: any;

  constructor(
    private toastMessage: ToastMessageService,
    private loaderService: LoaderService,
    private aiAgentService: AiAgentService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    // Set the default SharePoint token in local storage
    const defaultToken = 'eyJ0eXAiOiJKV1QiLCJub25jZSI6ImJ1ZTVLT2tsOFd3NnJnSzVLRWR2VXE3MUdpRElLTTRNd2p0MGx1eVhjMEEiLCJhbGciOiJSUzI1NiIsIng1dCI6ImltaTBZMnowZFlLeEJ0dEFxS19UdDVoWUJUayIsImtpZCI6ImltaTBZMnowZFlLeEJ0dEFxS19UdDVoWUJUayJ9.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.emJ9xvgltSJzHkbGbT_8Swkubhs9vSFcm0Dtlo9wVhbrya-2HNDNtJQsDbZffxLMk4fZoxFLyGXwmK5iczCzBAyNkREzi6xqJZzE8SnGYmDCjJO_9n6ffVthfwJFrzyqA5bSB6ZYPVStltola8tXUxvTEGqdAvejau_nP70lBF41EjNex7U3LJAqBFIFntDxqw2z4nvh5p9g-EqBRUfUxMZroMi6yfq3P7naxMvRAU0vKxdMVlPjogHT5jUBcnESZt0A3_tKeUTapBHY9LWdSDZl037J00csi3fYFNfXWvUI5b-cc5P4OcqSLMYfIvIl5nVEgA3JIELkKDt4rY-5Vw';
    localStorage.setItem('sharepoint-token', defaultToken);

    this.getWelcomeMessage();
  }


  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  ngOnDestroy(): void {
    if (this.chatSubscriber) {
      this.chatSubscriber.unsubscribe();
    }
  }

  selectBing(): void {
    this.isBingSelected = true;
    this.chatData = [];
    this.getWelcomeMessage();
    console.log('Bing selected');
  }

  onModelChange(): void {
    console.log(`Model changed to: ${this.selectedModel}`);
    this.chatData = [];
    this.getWelcomeMessage(); // Optionally reset the welcome message on model change
  }

  selectSharePoint(): void {
    this.isBingSelected = false;
    this.chatData = [];
    this.getWelcomeMessage();
    console.log('SharePoint selected');
  }

  getWelcomeMessage(): void {
    this.isLoading = true;
    this.aiAgentService.getWelcome()
      .then((res: any) => {
        this.isLoading = false;
        if (res && res.message) {
          if (this.isBingSelected) {
            this.welcomeChat = "Hi I'm your Research Agent, let me know the topic you want to research..";
          }
          else {
            this.welcomeChat = "Hi I'm your Search Assistant, let me know your query.."
          }
          this.chatData.push({ role: 'bot', content: this.welcomeChat });
          this.scrollToBottom();
        }
      })
      .catch((error: any) => {
        this.isLoading = false;
        this.toastMessage.showError('Failed to load welcome message');
      });
  }

  openModal(content: TemplateRef<any>) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      console.log(`Closed with: ${result}`);
    }, (reason) => {
      console.log(`Dismissed ${reason}`);
    });
  }

  sendMessage(): void {
    if (this.prompt.trim()) {
      this.isLoading = true;
      this.chatData.push({ role: 'user', content: this.prompt });

      // Define the API URL based on the selected search mode
      const apiUrl = this.isBingSelected ? 'http://65.0.27.103:5000/crews/bing/search' : 'http://65.0.27.103:5000/crews/sharepoint/ask-genpact';

      // Define the body type to accommodate query, goal, backstory, token, and model
      const body: { query: string; goal?: string; backstory?: string; token?: string; model?: string } = { query: this.prompt };

      body.model = this.selectedModel;


      if (this.isBingSelected) {
        if (this.goal) body.goal = this.goal;
        if (this.backstory) body.backstory = this.backstory;
      } else {
        const sharepointToken = localStorage.getItem('sharepoint-token');
        body.token = sharepointToken || '';  // Ensure token is a string
      }

      this.aiAgentService.sendQuery(apiUrl, body)
        .then((res: any) => {
          this.isLoading = false;
          if (res && res.message) {
            const chat = res.message.replace(/^```[\s\n]*|```$/g, '');
            this.chatData.push({ role: 'bot', content: chat });
            this.scrollToBottom();
          }
        })
        .catch((error: any) => {
          this.isLoading = false;
          this.toastMessage.showError('Failed to get response');
        });

      this.prompt = '';
    } else {
      this.toastMessage.showError('Please enter a message');
    }
  }

  scrollToBottom(): void {
    try {
      this.chatContainer.nativeElement.scrollTop = this.chatContainer.nativeElement.scrollHeight;
    } catch (err) {
      console.error('Scroll error:', err);
    }
  }

  copyToClipboard(content: string): void {
    navigator.clipboard.writeText(content).then(() => {
      console.log('Copied to clipboard');
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }

  regenerate(index: number) {
    this.prompt = this.chatData[index - 1]?.content;
    this.sendMessage();
  }

  autoResize(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  }

  handleEnter(): void {
    if (this.prompt.trim()) {
      this.sendMessage();
    }
  }

  inputPrompt(question: string): void {
    console.log(`Prompting with question: ${question}`);
  }

  newChat(): void {
    this.chatData = [];
    this.prompt = '';
    this.goal = '';
    this.backstory = '';
    this.getWelcomeMessage();
    console.log('Starting a new chat');
  }

  openGoalModal(content: TemplateRef<any>) {
    this.modalService.open(content, { ariaLabelledBy: 'goal-modal-title' }).result.then((result) => {
      if (result === 'save') {
        console.log('Goal saved:', this.goal);
      }
    }, (reason) => {
      console.log('Goal modal dismissed');
    });
  }

  openBackstoryModal(content: TemplateRef<any>) {
    this.modalService.open(content, { ariaLabelledBy: 'backstory-modal-title' }).result.then((result) => {
      if (result === 'save') {
        console.log('Backstory saved:', this.backstory);
      }
    }, (reason) => {
      console.log('Backstory modal dismissed');
    });
  }


  sentToInput(): void {
    this.sendMessage();
  }

}
